package co.maytes.standupbot.dashboard.components.widgets

import kotlinx.browser.window
import org.w3c.dom.HTMLElement

fun focusAfterRender(target: () -> HTMLElement?) {
    window.requestAnimationFrame {
        window.requestAnimationFrame { target()?.focus() }
    }
}
